<template>
  <div
    class="object-price"
  >
    <object-price-per-week
      v-if="!data.priceObject.price && priceMin > 0"
      :price-min="priceMin"
    />
    <!-- we have a price, show it! -->
    <object-price-duration
      v-if="showDuration"
      :duration="duration"
      :end-date-string="endDateString"
      :start-date-string="startDateString"
      class="object-price-duration"
    />
    <object-price-original
      v-if="data.priceObject.price > 0"
      :price="data.priceObject.price"
      :original="originalPrice"
      :currency="data.priceObject.currency"
      :price-complete="priceObject"
      :price-percent-reduction="data.priceObject.pricePercentReduction"
      class="object-price-original"
    />
  </div>
</template>

<script>
import { fromAPIDateString, toDateString } from 'utils/DateHelper';
import i18nHelper from 'utils/i18nHelper';
import ObjectPricePerWeek from 'components/ObjectPricePerWeek.vue';
import ObjectPriceDuration from 'components/ObjectPriceDuration.vue';
import ObjectPriceOriginal from 'components/ObjectPriceOriginal.vue';
import Booking from 'mixins/Booking';

/**
 * @@author        j0Shi
 * @@date          2019.08.20
 * @@desc          Price template for the object page
 * @@usedby        ObjectVacancyPrice -> ObjectVavancyForm > Object
 */
export default {
  name: 'ObjectPrice',
  components: {
    ObjectPricePerWeek,
    ObjectPriceDuration,
    ObjectPriceOriginal,

  },
  mixins: [
    Booking,
  ],
  props: {
    // min price from the object
    priceMin: {
      type: Number,
      default: 0,
    },
    // data from price request
    data: {
      type: Object,
      required: true,
    },
    hideDuration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18nHelper: i18nHelper(this.$i18n.i18next),
      lang: {
        dateFormat: 'dd.MM.yyyy',
      },
    };
  },
  computed: {
    priceData() {
      return this.data;
    },
    duration() {
      return this.data.priceObject.duration;
    },
    // returns the localized start date string depending on the price data
    startDateString() {
      return this.data.priceObject.startDate !== null ? toDateString(fromAPIDateString(this.data.priceObject.startDate)) : '';
    },
    // returns the localized end date string depending on the price data
    endDateString() {
      return this.data.priceObject.endDate !== null ? toDateString(fromAPIDateString(this.data.priceObject.endDate)) : '';
    },
    // boolean that checks for a filled startDateString
    hasDate() {
      return this.data.priceObject.startDate !== null;
    },
    showDuration() {
      return !this.hideDuration && this.data.priceObject.price !== null;
    },
  },
  created() {
    // fetches calendar format from language files and saves it in data
    // necessary because language json is lazy loaded and might not be available on creation
    const self = this;
    this.i18nHelper.checkKey('date:calendarDateFormat').then(() => {
      self.lang.dateFormat = self.$t('date:calendarDateFormat');
    }).catch(() => {
      // eslint-disable-next-line no-console
      console.warn('couldn\'t fetch flatpickr languages, using default instead');
    });
  },
};
</script>
